import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=f870060c&scoped=true&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"
import style0 from "../../less/turntable.less?vue&type=style&index=0&id=f870060c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870060c",
  null
  
)

export default component.exports